module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setting-wrap"
  }, [_c('el-collapse', {
    attrs: {
      "accordion": ""
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.activeNames),
      callback: function($$v) {
        _vm.activeNames = $$v
      },
      expression: "activeNames"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "配置项目",
      "name": "1"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.con),
      expression: "con"
    }],
    staticClass: "el-textarea__inner",
    attrs: {
      "rows": "3",
      "placeholder": "请输入项目名称，以中文逗号分隔，输入完，按Enter键完成配置"
    },
    domProps: {
      "value": (_vm.con)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.con = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "title": "使用说明",
      "name": "2"
    }
  }, [_c('ol', [_c('li', [_vm._v("默念“"), _c('span', {
    staticClass: "special"
  }, [_vm._v("作者真帅")]), _vm._v("”3遍")]), _vm._v(" "), _c('li', [_vm._v("前往 "), _c('a', {
    staticClass: "special",
    attrs: {
      "href": "https://github.com/JasonBai007",
      "target": "_blank",
      "title": "Github"
    }
  }, [_vm._v("全球最大男性交友社区")]), _vm._v(" 为作者点赞")]), _vm._v(" "), _c('li', [_vm._v("配置项目（输入项目名称，以中文逗号分隔，输入完，按Enter键完成配置）")]), _vm._v(" "), _c('li', [_vm._v("开始使用")])])]), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "title": "勾搭作者",
      "name": "3"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/weixin.jpg"),
      "alt": "",
      "width": "240"
    }
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b4908c04!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Setting.vue
// module id = 183
// module chunks = 1